import { render, staticRenderFns } from "./modal-upload-certificate.vue?vue&type=template&id=52bc0838&scoped=true"
import script from "./modal-upload-certificate.vue?vue&type=script&lang=js"
export * from "./modal-upload-certificate.vue?vue&type=script&lang=js"
import style0 from "./modal-upload-certificate.vue?vue&type=style&index=0&id=52bc0838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc0838",
  null
  
)

export default component.exports